// Typed JSONL record shapes for the ingest pipeline (§7). Records are name-based
// and pre-canonicalization; Pass5 assigns final ids. Content is plain text (no
// inline entity tags); scene-level cast/props are declared on the scene record
// (from source `人物：`/`道具：` lines) and augmented by the extract pass.

import {
  NON_ACTOR_SPEAKER_KINDS,
  type NonActorSpeakerKind,
} from "../script/shared/types.js";

export type SourceSpan = { chunk: number; line_start: number; line_end: number };

// A name-based entity reference with an optional (declared) state description.
export type NameStateRef = { name: string; state?: string };

export type SpeakerRef =
  | { name: string; state?: string }
  | { kind: NonActorSpeakerKind; label?: string };

// Non-actor speaker kinds. Bit-part characters (龙套) are still actors (tagged
// importance=background), so they speak via actor_id — no special speaker kind.
export { NON_ACTOR_SPEAKER_KINDS };

export type EpisodeRecord = { kind: "episode"; episode: number; title?: string; source: SourceSpan };
export type SceneRecord = {
  kind: "scene";
  scene?: number;
  environment?: { space?: string; time?: string };
  location?: { name: string; state?: string };
  actors?: NameStateRef[]; // declared cast (源『人物：名【状态】』)
  props?: NameStateRef[]; // declared props (源『道具：』)
  source: SourceSpan;
};
export type ActionRecord = { kind: "action"; content: string; source: SourceSpan };
export type DialogueRecord = { kind: "dialogue"; speaker: SpeakerRef; content: string; emotion?: string; source: SourceSpan };
export type InnerThoughtRecord = { kind: "inner_thought"; speaker: SpeakerRef; content: string; emotion?: string; source: SourceSpan };
export type TransitionRecord = { kind: "transition"; content: string; source: SourceSpan };
export type NoteRecord = { kind: "note"; content: string; category?: "author_note" | "format_note" | "unclassified"; source: SourceSpan };

export type IngestRecord =
  | EpisodeRecord
  | SceneRecord
  | ActionRecord
  | DialogueRecord
  | InnerThoughtRecord
  | TransitionRecord
  | NoteRecord;

export const RECORD_KINDS = ["episode", "scene", "action", "dialogue", "inner_thought", "transition", "note"] as const;
export type RecordKind = (typeof RECORD_KINDS)[number];
